<template>
  <div>
    <h1 class="title">Utenti</h1>
    <div class="section has-text-left">
      <router-link to="/user" class="button is-success">
        <b-icon icon="plus-square" size="is-small"></b-icon>
        <span>Aggiungi</span>
      </router-link>
    </div>

    <section class="content">
      <SearchUserAsync
        v-on:eventGotResults="handleGotResults"
      ></SearchUserAsync>
    </section>

    <section>
      <b-table
        :data="users"
        :paginated="isPaginated"
        :per-page="perPage"
        :current-page.sync="currentPage"
        :pagination-simple="isPaginationSimple"
        :default-sort-direction="defaultSortDirection"
        :pagination-range-before="5"
        :pagination-range-after="5"
        :loading="$ajax.anyLoading"
        striped
        class="has-text-left"
      >
        <template>
          <b-table-column field="actions" width="50" v-slot="props">
            <ul>
              <li v-if="!$ajax.getObject('roles', props.row.roleId).isClient">
                <b-tooltip label="Visualizza schede" position="is-right">
                  <router-link :to="`/cards?user_id=${props.row.id}&page=1`">
                    <button class="button is-small">
                      <b-icon icon="newspaper" size="is-small"></b-icon>
                    </button>
                  </router-link>
                </b-tooltip>
              </li>
              <li v-if="$ajax.getObject('roles', props.row.roleId).isClient">
                <b-tooltip label="Visualizza prodotti" position="is-right">
                  <router-link :to="`/user/${props.row.id}/products`">
                    <button class="button is-small">
                      <b-icon icon="cookie-bite" size="is-small"></b-icon>
                    </button>
                  </router-link>
                </b-tooltip>
              </li>
            </ul>
          </b-table-column>

          <b-table-column
            field="name"
            label="Nominativo"
            width="300"
            v-slot="props"
          >
            <router-link :to="`/user/${props.row.id}`">
              <i class="fas fa-edit"></i>
              {{ props.row.name }}
            </router-link>
          </b-table-column>

          <b-table-column field="email" label="Email" v-slot="props">{{
            props.row.email
          }}</b-table-column>

          <b-table-column
            field="role"
            label="Ruolo"
            width="200"
            v-slot="props"
            >{{
              $ajax.getObject("roles", props.row.roleId).name
            }}</b-table-column
          >

          <b-table-column
            field="enabled"
            width="30"
            label="Abilitato"
            v-slot="props"
          >
            <span v-if="props.row.enabled">
              <b-icon icon="check" size="is-small" type="is-success"></b-icon>
            </span>
            <span v-else>
              <b-icon icon="ban" size="is-small" type="is-danger"></b-icon>
            </span>
          </b-table-column>

          <b-table-column
            field="updatedat"
            width="50"
            label="Updated"
            v-slot="props"
            centered
          >
            <span class="tag">{{ props.row.updatedAt | date }}</span>
          </b-table-column>
        </template>

        <template slot="empty">
          <section class="section">
            <div class="content has-text-grey has-text-centered">
              <p>
                <b-icon icon="user" size="is-large"></b-icon>
              </p>
              <p>Lista utenti vuota</p>
            </div>
          </section>
        </template>
      </b-table>
    </section>
  </div>
</template>

<script>
//import data from "@/data/sample.json";
import SearchUserAsync from "../components/SearchUserAsync";

export default {
  name: "users",
  components: { SearchUserAsync },
  data() {
    return {
      users: [],
      isPaginated: true,
      isPaginationSimple: false,
      defaultSortDirection: "asc",
      currentPage: 1,
      perPage: 20,
    };
  },
  methods: {
    handleGotResults(users) {
      this.users = users;
    },
  },

  mounted() {
    const vm = this;
    this.$ajax.request({
      address: "/users/search/",
      method: "GET",
      onSuccess: (response) => {
        response.data.forEach((item) => vm.users.push(item));
      },
    });
  },
};
</script>